// Module
var code = "<template> <typeahead-input data.bind=\"stateList\" value.bind=\"selectedState\" placeholder=\"Select State\" validation.bind=\"validation\" init-value.bind=\"selectedState\" results-limit.bind=\"stateList.length\" disabled.bind=\"disabled\"> </typeahead-input> </template> ";
// Exports
export default code;